import { render, staticRenderFns } from "./Legend.vue?vue&type=template&id=34724886&"
import script from "./Legend.vue?vue&type=script&lang=js&"
export * from "./Legend.vue?vue&type=script&lang=js&"
import style0 from "./Legend.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/bsjung/work/xtc/trading-chart-js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34724886')) {
      api.createRecord('34724886', component.options)
    } else {
      api.reload('34724886', component.options)
    }
    module.hot.accept("./Legend.vue?vue&type=template&id=34724886&", function () {
      api.rerender('34724886', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Legend.vue"
export default component.exports